import { render, staticRenderFns } from "./drPropertyWithGear.vue?vue&type=template&id=18087424&"
import script from "./drPropertyWithGear.vue?vue&type=script&lang=js&"
export * from "./drPropertyWithGear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports